import React, { FunctionComponent, useState } from 'react'
import styles from './ColorPicker.module.sass'
import ShadowContainer from '../../../etc/popover/ShadowContainer/ShadowContainer'
import Color from './Color'
import Popover from '../../../etc/Popover'
import clsx from 'clsx'
import DropdownElement from '../../dropdowns/DropdownElement/DropdownElement'
import { chunksOf } from 'fp-ts/Array'

export const BASE_COLORS = ['#9FB9FA', '#D0B2F5', '#FFC7F9', '#FFB8B8', '#8F99F4', '#6CC1F1', '#F39EE1', '#F2AB82', '#F7E797', '#D3F1A3', '#ABEBC8', '#BBEFFB', '#FFE5CC', '#FFCCEE', '#FFCCCC', '#CCCCFF', '#CCEEFF', '#FFEECC', '#FFFFCC', '#E6FFCC', '#CCFFE6', '#CCFFFF']
const COLORS = chunksOf(4)(BASE_COLORS)

interface Props {
    value?: string,
    text?: string,
    selected: string[],
    onChange: (value: string) => void,
}

const ColorPicker: FunctionComponent<Props> = props => {
    const [open, setOpen] = useState(false)
    return <Popover
        isOpen={open}
        positions={['bottom']}
        onClickOutside={() => setOpen(false)}
        content={state => <ShadowContainer
            className={styles.container}
            state={state}
            style={{ gridTemplateColumns: `repeat(${COLORS[0].length}, max-content)` }}
        >
            {
                COLORS.map(row => row.map(color => <Color
                    key={color}
                    color={color}
                    active={color === props.value}
                    selected={props.selected.includes(color)}
                    onClick={() => {
                        props.onChange(color)
                        setOpen(false)
                    }}
                >
                    {props.text}
                </Color>))
            }
        </ShadowContainer>}
    >
        <DropdownElement
            active={open}
            className={clsx(styles.picker, { [styles.open]: open })}
            onToggle={setOpen}
        >
            <div>Цвет <Color color={props.value ?? 'white'}>{props.text}</Color></div>
        </DropdownElement>
    </Popover>
}

export default ColorPicker